// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-shareto>.center-bar:not(:first-child),.content-shareto>.center-bar>.content-main>.content-party{margin-top:10px}", ""]);
// Exports
module.exports = exports;
